import * as React from 'react';
import DocumentTitle from 'react-document-title';

import { BillingPageHeader } from '../components/billing-page-header';
import { Invoices } from '../components/invoices';

export const InvoicesPage: React.FC = () => (
    <DocumentTitle title="Invoices">
        <div id="container">
            <BillingPageHeader />
            <div id="content" className="flex-fill">
                <Invoices />
            </div>
        </div>
    </DocumentTitle>
);
